module.exports = __webpack_public_path__ + "media/vue/assets/images/qr-codes/kr_getapp-4a393166f23140e4139809bdf392453d.png";